

export interface IProjectBudgetListRequest {
    organisationId: number;
    status: number;
    pageNo: number;
    sortOrder: number;
    sortColumn: string;
    searchText: string;
    entityType: number;
}

export class ProjectBudgetListRequest implements IProjectBudgetListRequest {
    organisationId: number;
    status: number;
    pageNo: number;
    sortOrder: number;
    sortColumn: string;
    searchText: string;
    entityType: number;
    constructor(organisationId: number, status: number, pageNo: number, sortOrder: number, sortColumn: string, searchText: string,
        entityType: number) {
        this.organisationId = organisationId;
        this.status = status;
        this.pageNo = pageNo;
        this.sortOrder = sortOrder;
        this.sortColumn = sortColumn;
        this.searchText = searchText;
        this.entityType = entityType;
    }
}

export interface IProjectBudgetGridResponse {
    totalBudget: number,
    actualSpent: number,
    available: number,
    projectsCounts: number,
    overUnder: string,
    projectBudgetDetailsId: number,
    entityId: number,
    entityName: string,
    entityType: number,
    organisationId: number,
    userId: number,


    updatedOnForSort: Date;

    isRowHighlighted: boolean;
    selected: boolean;
}

export class ProjectBudgetGridResponse implements IProjectBudgetGridResponse {
    totalBudget: number;
    actualSpent: number;
    available: number;
    projectsCounts: number;
    overUnder: string;
    projectBudgetDetailsId: number;
    entityId: number;
    entityName: string;
    entityType: number;
    organisationId: number;
    userId: number;
    updatedOn: number;
    updatedOnForSort: Date;
    isRowHighlighted: boolean;
    selected: boolean;

}

export interface IProjectBudgetListResponse {
    projectBudgetList: IProjectBudgetGridResponse[];
    totalCount: number;
    costCentreCount: number;
    customerCount: number;
}

export class ProjectSummaryPopupModel {
    constructor(public projectBudgetDetailsId: number, public entityType: number, public entityName: string) { }
}

export class ProjectSummary {
    projectCode: string;
    projectName: string;
    projectBudget: number;
    actual: number;
    available: number;
    used: number;
    overUnder: string;
}

export class ProjectSummaryResponse {
    projectSummaryList: ProjectSummary[];
    totalBudget: number;
    totalActual: number;
    totalAvailable: number;
}

export class ProjectSummaryRequest {
    constructor(public projectBudgetDetailsId: number, public organisationId: number) { }
}

export class ProjectBudgetOperationPopupModel {
    constructor(public projectBudgetDetailsId: number) { }
}

export class GetCustomerCostCentreListRequest {
    constructor(public organisationId: number, public includeCostCentre: boolean, public includeCustomer: boolean) { }
}

export class CostCentreCustomerList {
    entityId: number;
    entityName: string;
    entityType: number;
    projectBudgetDetailsId: number;
    disabled: boolean;
    mergedEntityName: string;
}

export class GetActiveEmployeesForProjectBudgetRequest {
    constructor(public organisationId: number) { }
}

export class GetActiveEmployeesForProjectBudgetResponse {
    userId: number;
    userName: string;
    loginId: string;
    orgRoleId: number;
    mergedUserName: string;
}

export class GetProjectBudgetAllDetailsByProgBudIdRequest {
    constructor(public projectBudgetDetailsId: number, public organisationId: number) {

    }
}

export class BudgetDetailsResponse {
    budgetDetailsId: number;
    projectBudgetDetailsId: number;
    totalBudget: any;
    status: number;
    approvalRule: number;
    overallSpendAlertAmount: any;
    overallSpendEMailToUserId: number;
    overallSpendEMailSent: boolean;
    organisationId: number;
}

export class ProjectDetailsResponse {
    projectDetailsId: number;
    projectBudgetDetailsId: number;
    projectCode: string;
    projectName: string;
    projectManagerId: number;
    projectBudget: number;
    isBillable: boolean;
    status: number;
    organisationId: number;
    isProjectContainsExpense: boolean;
    projectAlertDetails: ProjectAlertDetailsResponse[];
    projectAlertRecipients: ProjectAlertRecipientsResponse[];
    updatedBy: number;
    updatedOn: number;
    closedType: number;
    spentAmount: number;
}

export class ProjectAlertDetailsResponse {
    projectAlertDetailsId: number;
    projectDetailsId: number;
    expenseCategoryId: number;
    expenseCategoryBudget: number;
    alert1: number;
    alert2: number;
    alert3: number;
    alert1EmailSent: boolean;
    alert2EmailSent: boolean;
    alert3EmailSent: boolean;
    organisationId: number;
}

export class ProjectAlertRecipientsResponse {
    projectAlertRecipientsId: number;
    projectDetailsId: number;
    recipientsUserId: number;
    organisationId: number;
}

export class ProjectBudgetResponse {
    projectBudgetDetailsId: number;
    entityId: number;
    entityName: string;
    entityType: number;
    organisationId: number;
    userId: number;
    createdBy: number;
    createdOn: number;
    updatedBy: number;
    updatedOn: number;
    budgetDetails: BudgetDetailsResponse;
    projectDetails: ProjectDetailsResponse[];
}

export class ProjectCategorySummaryRequest {
    constructor(public projectBudgetDetailsId: number, public organisationId: number) { }
}

export class CategorySummaryDetailsResponse {
    expenseCategoryId: number;
    expenseCategoryBudget: number;
    expenseCategoryName: string;
    expenseCategoryActual: number;
    expenseCategoryAvailable: number;
    overUnder: string;
    used: number;
}

export class CategorySummaryResponse {
    projectDetailsId: number;
    projectCode: string;
    projectName: string;
    projectManagerId: number;
    projectManagerName: string;
    projectBudget: number;
    categorySummaryDetailsResponse: CategorySummaryDetailsResponse[];
}

export class ProjectBudgetForEntity {
    entityId: number;
}

export class GetProjectBudgetByEntityTypeRequest {

    constructor(public organisationId: number, public entityTypeId: number) { }
}

export class GetProjectManagerCountRequest {
    constructor(public organisationId: number) { }
}

export class ProjectManagerDetails {
    projectManagerId: number;
    projectCount: number;
}

export class UpdateProjectManagerRequest {
    constructor(public oldApproverId: number, public newApproverId: number, public organisationId: number, public claimantsIds: number[]) { }
}

export class GetProjectListForCloseModel {
    projectBudgetDetailsId: number;
    projectDetailsId: number;
    entityName: string;
    entityType: string;
    projectName: string;
    projectCode: string;
    projectBudget: number;
    projectManager: string;
    status: string;
    selected: boolean;
    updatedOn: number;
    isRowHighlighted: boolean;
    tempStatus: string;
    closedType: number;
    spentAmount: number;
}

export class GetProjectListForCloseResponse {
    projectList: GetProjectListForCloseModel[];
    totalProjectsCount: number;
    totalCustomersProjectsCount: number;
    totalCostCentreProjectsCount: number;
    totalOpenProjectsCount: number;
    totalClosedProjectsCount: number;
}

export class CloseProjectRequest {
    constructor(public projectBudgetDetailsId: number, public projectDetailsId: number, public organisationId: number, public userId: number, public closedType: number, public spentAmount: number, public userName: string) { }
}




export interface IGetCustomerCostCentreProjectsListRequest {
    organisationId: number;
    userId: number;
    includeCostCentre: boolean;
    includeCustomer: boolean;
}

export class GetCustomerCostCentreProjectsListRequest implements IGetCustomerCostCentreProjectsListRequest {
    organisationId: number;
    userId: number;
    includeCostCentre: boolean;
    includeCustomer: boolean;
    constructor(organisationId: number, userId: number, includeCostCentre: boolean, includeCustomer: boolean) {
        this.organisationId = organisationId;
        this.userId = userId;
        this.includeCostCentre = includeCostCentre;
        this.includeCustomer = includeCustomer;
    }
}

export interface ICostCentreCustomerProjectListResponse {
    customerCostCentreProjectList: CostCentreCustomerProjectList[];
}

export class CostCentreCustomerProjectListResponse implements ICostCentreCustomerProjectListResponse {
    customerCostCentreProjectList: CostCentreCustomerProjectList[];
}

export class CostCentreCustomerProjectList {
    entityId: number;
    entityName: string;
    entityCode:string;
    entityType: number;
    isHomeCostCentre: boolean;
    projectBudgetDetailsId: number;
    projectList: ProjectInfo[]
}

export class ProjectInfo {
    projectDetailsId: number;
    projectCode: string;
    projectName: string;
}


//NEW CODE P&B ******************

export interface IEntityDetailsListResponse {
    entityList: IEntityDetails[];
    totalBudget: number;
    totalSpent: number;
    totalVariance: number;
    totalProjects: number;
    totalClaimants: number;
}

export class EntityDetailsListResponse implements IEntityDetailsListResponse {
    entityList: IEntityDetails[];
    totalBudget: number;
    totalSpent: number;
    totalVariance: number;
    totalProjects: number;
    totalClaimants: number;
}

export interface IEntityDetails
{
    entityConfigId: number;
    entityId: number;
    entityName: string;
    entityType: number;
    budget: number;
    totalSpent: number;
    variance: number;
    underOrOver: boolean;
    status: number;
    utilisation: number;
    projectsList: IProjectDisplayInfo[];
    claimantsList: IClaimantDisplayInfo[];
}

export class EntityDetails implements IEntityDetails
{
    entityConfigId: number;
    entityId: number;
    entityName: string;
    entityType: number;
    budget: number;
    totalSpent: number;
    variance: number;
    underOrOver: boolean;
    status: number;
    utilisation: number;
    projectsList: IProjectDisplayInfo[] = [];
    claimantsList: IClaimantDisplayInfo[] = [];
}

export interface IProjectDisplayInfo
{
    projectCode: string;
    projectName: string;
    projectConfigId: number;
    entityConfigId: number;
}

export interface IClaimantDisplayInfo
{
    entityConfigId: number;
    projectConfigId: number;
    claimantId: number;
    linkType: number;
    claimantName: string;
}
export interface ICheckEntityExistsResponse {
    entityExists: boolean;
}

export interface IDropdownEntityDetails {
    entityName: string;
    entityId: string;
    entityType: number;
    isConfigured?: boolean;
}

export interface IAvailableEntityListResponse {
    dropdownEntityList: IDropdownEntityDetails[];
}

export interface IAlertDetails {
    alertId: number;
    itemId: number;
    sequence: number;
    alertValue: number;
    alertType: number;
    linkType: number;
}
export interface IAssignedApproverDetails {
    entityApproverMappingId: number;
    entityApproverId: number;
    linkType: number;
    approverName: string;
}

export interface IProjectManager {
    pMMappingId: number;
    userId: number;
    itemId: number;
    linkType: number;
    displayName: string;
}

export interface IDropdownApproverDetails {
    entityApproverMappingId: number;
    entityApproverId: number;
    linkType: number;
    approverName: string;
}

export interface IAvailableApproverListResponse {
    dropdownApproverList: IDropdownApproverDetails[];
}

export interface IEntityConfigDetails {
    entityConfigId: number;
    entityId: number;
    entityName: string;
    entityType: number;
    isEntityBillable: boolean;
    budget: number;
    orgId: number;
    isBudgetSet: number;
    sumOfProjectBudgets: number;
    alertList: IAlertDetails[];
    assignedEntityApproverList: IAssignedApproverDetails[];
}

export interface IProjectConfigDetails {
    projectConfigId: number;
    entityConfigId: number;
    projectCode: string;
    projectName: string;
    isProjectBillable: boolean;
    projectBudget: number;
    projectApprovalRule: number;
    orgId: number;
    status: number;
    alertList: IAlertDetails[];
    projectPMList: IProjectManager[];
}

export class ProjectDisplayInfo
{
    projectCode: string;
    projectName: string;
    projectConfigId: number;
    entityConfigId: number;
}

export class ClaimantDisplayInfo
{
    entityId: number;
    claimantLinkType: number;
    claimantName: string;
}

export interface IEntitySaveDetailsRequest {
    currentEntityConfigDetails: IEntityConfigDetails;
    oldEntityConfigDetails: IEntityConfigDetails | null;
    action: number;
}

export interface IProjectsSaveDetailsRequest {
    currentProjectConfigDetails: IProjectConfigDetails;
    oldProjectConfigDetails: IProjectConfigDetails | null;
    saveType: number;
    action: number;
}

export interface ISaveItemDetailsResponse {
    response: string;
    status: boolean;
    itemId: number;
}


export interface IProjectDetailByEntityRequest {
    entityConfigId: number;
    orgId: number | 0;
    linkType: number;
}

export interface IProjectDetailRequest {
    projectConfigId: number;
    orgId: number | 0;
    linkType: number;
}

export interface IEntityDetailsForProjectsResponse {
    entityName: string;
    entityId: number;
    entityConfigId: number;
    entityType: number;
    overallEntityBudget: number;
    budgetRemaining: number;
    entityApprovalRule: number;
    isEntityBillable: boolean;
    isBudgetSet: number;
    pmList: ProjectManager[];
}

export class EntityDetailsForProjectsResponse implements IEntityDetailsForProjectsResponse {
    entityName: string;
    entityId: number;
    entityConfigId: number ;
    entityType: number;
    overallEntityBudget: number;
    budgetRemaining: number;
    entityApprovalRule: number;
    isEntityBillable: boolean;
    isBudgetSet: number;
    pmList: ProjectManager[];
    constructor() {
        this.entityName = '';
        this.entityId = 0;
        this.entityConfigId = 0;
        this.entityType = 0;
        this.overallEntityBudget = 0;
        this.budgetRemaining = 0;
        this.entityApprovalRule = 0;
        this.isEntityBillable = false;
        this.isBudgetSet = 0;
        this.pmList = [];
    }
}

export interface ProjectDetailsList
{
    projectList: ProjectListConfigDetails[];
}

export interface ProjectListConfigDetails
{
    projectConfigId: number;
    entityConfigId: number;
    projectCode: string;
    projectName: string;
    isProjectBillable: boolean;
    projectBudget: number;
    projectApprovalRule: number;
    orgId: number;
    projectPMList: ProjectManager[];
}

export interface ProjectManager {
    pMMappingId: number;
    userId: number;
    itemId: number;
    linkType: number;
    displayName: string;
}

export interface ISaveApprovalRuleRequest {
    approvalRule: number;
    oldApprovalRule: number;
    organisationId: number;
    itemConfigId: number;
    linkType: number;
    projectManagerList: ProjectManager[];
    oldProjectManagerList: ProjectManager[];
}

export interface ISaveApprovalRuleResponse {
    response: string;
    status: boolean;
}

export interface IProjectBillableStatus {
    currentBillableStatus: boolean;
    oldBillableStatus: boolean;
    organisationId: number;
    projectName: string;
    projectConfigId: number;
    entityConfigId: number;
    approvalRule: number;
}

export interface IBulkBillableStatusRequest {
    projectBillableStatusList: IProjectBillableStatus[];
}

// ─── Expense Category Panel (Step 3) ───────────────────────────────────────

export interface CategoryAlertDetails {
    alertId: number;
    itemId: number;
    tempId: number;
    sequence: number;
    alertValue: number;
    alertType: number;
    linkType: number;
}
export interface IExpenseCategoryPBMapping {
    expenseCategoryProjectBudgetMappingId: number;
    itemId: number;
    expenseCategoryId: number;
    budget: number;
    budgetSpentAmount: number;
    linkType: number;
    expenseCategoryName: string;
    alertList: CategoryAlertDetails[];
}

export interface IProjectDetailsForExpenseCategory {
    projectName: string;
    projectConfigId: number;
    orgId: number;
    overallProjectBudget: number;
    budgetRemaining: number;
    expenseCategoryList: IExpenseCategoryPBMapping[];
    emailRecipientList: DropdownEmailRecipientDetails[];
}

export interface IProjectsDetailsForExpenseCategoryResponse {
    projectsDetails: IProjectDetailsForExpenseCategory[];
}

export interface ICategoryGridRow {
    expenseCategoryId: number;
    expenseCategoryName: string;
    budget: number | null;
    alert1Percent: number | null;
    alert1Amount: number | null;
    alert2Percent: number | null;
    alert2Amount: number | null;
    alert3Percent: number | null;
    alert3Amount: number | null;
    mappingId: number;
    budgetError?: string | null;
    alert1PercentError?: string | null;
    alert2PercentError?: string | null;
    alert3PercentError?: string | null;
    budgetTouched?: boolean;
}

export interface IProjectCategoryState {
    projectConfigId: number;
    projectName: string;
    overallProjectBudget: number;
    selectedCategoryIds: number[];
    gridData: ICategoryGridRow[];
    quickSetAlerts: { alert1: number | null; alert2: number | null; alert3: number | null };
    emailRecipients: number[];
    isDirty: boolean;
}

export interface IAvailableEmailRecipientListResponse {
    dropdownRecipientList: DropdownEmailRecipientDetails[];
}

export class DropdownEmailRecipientDetails{
    recipientMappingId: number // primary key of recipient Mapping Id
    recipientUserId: number  // EMpId of Employee
    itemId: number // can be either projectConfigId or entityConfigId based on linkType
    linkType: number
    recipientName: string // Emp Name
    email: string  // Emp Name
}

export interface IActiveClaimantListResponse {
    claimantList: IActiveClaimantItem[];
}

export interface IActiveClaimantItem {
    userId: number;
    userName: string;
    email: string;
    costCentreName: string;
}

export interface IExpenseCategoryPBMappingSave {
    expenseCategoryProjectBudgetMappingId: number;
    itemId: number;
    tempId: number;
    expenseCategoryId: number;
    budget: number;
    budgetSpentAmount: number;
    linkType: number;
    expenseCategoryName: string;
    alertList: IAlertDetails[];
}

export interface IProjectDetailsForCategorySave {
    projectName: string;
    projectConfigId: number;
    entityConfigId: number;
    orgId: number;
    overallProjectBudget: number;
    budgetRemaining: number;
    expenseCategoryList: IExpenseCategoryPBMappingSave[];
    emailRecipientList: DropdownEmailRecipientDetails[];
}

export interface ICategoriesSaveDetailsRequest {
    projectExpenseCategoryDetail: IProjectDetailsForCategorySave;
}

export interface IBulkCategoriesSaveDetailsRequest {
    projectAndCategoriesDetails: ICategoriesSaveDetailsRequest[];
}

export interface ISaveBulkCategorieDetailsResponse {
    saveItemDetailsResponses: ISaveItemDetailsResponse[];
}

// UC8 — Claimant Assignment
export interface IClaimantMappingDetails {
    claimantMappingId: number;
    claimantId: number;
    itemId: number;
    linkType: number;
    orgId: number;
    claimantName: string;
}

export interface IProjectsClaimantMapping {
    projectConfigId: number;
    projectName: string;
    entityConfigId: number;
    assignedClaimantList: IClaimantMappingDetails[];
}

export interface IEntityClaimantMapping {
    entityConfigId: number;
    entityType: number;
    entityName: string;
    projectsList: IProjectsClaimantMapping[];
    assignedClaimantList: IClaimantMappingDetails[];
}

export interface IProjectsEntitiesClaimantMapping {
    entitiesList: IEntityClaimantMapping[];
}

export interface IGetProjectEntitiesRequest {
    orgId: number;
    isBulkMode: boolean;
    itemId: number;
    linkType: number;
}

export interface IItemClaimantMappingDetails {
    itemId: number;
    linkType: number;
    entityConfigId: number;
    itemName: string;
    assignedClaimantList: IClaimantMappingDetails[];
}

export interface ISaveEntityProjectClaimantMappingRequest {
    orgId: number;
    itemsClaimantMappingList: IItemClaimantMappingDetails[];
}

export interface IGenericResponse {
    response: string;
    status: boolean;
}

// Entity Dashboard Panel interfaces

export interface IEntityDashboardRequest {
    entityConfigId: number;
    orgId: number;
}

export interface IEntityDashboardOverview {
    entityConfigId: number;
    entityName: string;
    entityType: number;
    entityCode1: string;
    entityCode2: string;
    status: number;
    budget: number;
    totalSpent: number;
    variance: number;
    utilisation: number;
    projectsCount: number;
    claimantsCount: number;
    isBudgetSet: number;
    topExpenseCategories: IEntityDashboardTopCategory[];
}

export interface IEntityDashboardProject {
    projectConfigId: number;
    entityConfigId: number;
    projectCode: string;
    projectName: string;
    status: number;
    budget: number;
    totalSpent: number;
    utilisation: number;
    createdOn: number;
    claimantsCount: number;
    pendingClaimsCount: number;
    pendingClaimsAmount: number;
}

export interface IEntityDashboardClaimant {
    claimantId: number;
    claimantName: string;
    email: string;
    amountSpent: number;
    expensesSubmitted: number;
}

export interface IEntityDashboardTopCategory {
    orgExpenseCategoryId: number;
    categoryName: string;
    totalAmount: number;
}

export interface IEntityDashboardDetails {
    overview: IEntityDashboardOverview;
    projectsList: IEntityDashboardProject[];
    claimantsList: IEntityDashboardClaimant[];
}

// Import flow interfaces

export interface IGetEntitiesForImportRequest {
    orgId: number;
    entityConfigId: number;
}

export interface IEntityImportItem {
    entityConfigId: number;
    entityName: string;
    entityType: number;
    status: number;
    assignedClaimantsCount: number;
    projectsCount: number;
}

export interface IEntitiesForImportResponse {
    entities: IEntityImportItem[];
}

export interface IGetProjectsForImportRequest {
    orgId: number;
    entityConfigIds: number[];
}

export interface IProjectImportItem {
    projectConfigId: number;
    projectName: string;
    projectCode: string;
    assignedClaimantsCount: number;
    entityConfigId: number;
}

export interface IEntityProjectsImportItem {
    entityConfigId: number;
    entityName: string;
    entityType: number;
    projects: IProjectImportItem[];
}

export interface IProjectsForImportResponse {
    entities: IEntityProjectsImportItem[];
}

export interface IRerouteProjectAndBudgetExpensesRequest{
    entityConfigId: number;
    projectConfigId: number;
    orgId: number;
}

export class RerouteProjectAndBudgetExpensesRequest implements IRerouteProjectAndBudgetExpensesRequest{
    entityConfigId: number;
    projectConfigId: number;
    orgId: number
}

export interface IRerouteProjectAndBudgetExpensesResponse{
    status: boolean;
    response: string;
}

export class RerouteProjectAndBudgetExpensesResponse implements IRerouteProjectAndBudgetExpensesResponse{
    status: boolean;
    response: string;
}

export interface IPBPendingExpenseCountResponse{
    entityConfigId: number;
    projectConfigId: number;
    pendingCount: number;
}

